import { MultiInputStreamBasePlainObject } from './multiInputStreamBase.plainObject';
import { SortExpressionPlainObject } from './sortExpression.plainObject';

export class LookupPlainObject extends MultiInputStreamBasePlainObject {
    public sortExpressions: SortExpressionPlainObject[] = [];
}
